
import React from "react";
import { format, isToday, isPast, startOfDay } from "date-fns";
import { pt, enUS, es, fr } from "date-fns/locale";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/components/LanguageContext";

interface WeekHeaderProps {
  weekDays: Date[];
}

export const WeekHeader: React.FC<WeekHeaderProps> = ({ weekDays }) => {
  const { language } = useLanguage();
  
  const getDateLocale = () => {
    switch (language) {
      case 'pt': return pt;
      case 'es': return es;
      case 'fr': return fr;
      default: return enUS;
    }
  };
  
  const dateLocale = getDateLocale();
  
  return (
    <>
      <div className="h-20 border-b border-gray-300 dark:border-gray-700 z-10 sticky left-0 bg-gray-50 dark:bg-gray-800" />
      {weekDays.map(day => {
        const today = isToday(day);
        const past = isPast(startOfDay(day)) && !today;
        
        return (
          <div 
            key={day.toISOString()} 
            className={cn(
              "text-center p-4 border-b border-gray-300 dark:border-gray-700",
              past && "opacity-50",
              today && "bg-primary/10 dark:bg-primary/20"
            )}
          >
            <div className={cn(
              "font-medium",
              today ? "text-primary dark:text-primary" : "dark:text-gray-200"
            )}>
              {format(day, "eee", { locale: dateLocale })}
            </div>
            <div className={cn(
              "text-sm",
              today 
                ? "bg-primary text-primary-foreground rounded-full w-7 h-7 flex items-center justify-center mx-auto font-semibold" 
                : "text-muted-foreground dark:text-gray-400"
            )}>
              {format(day, "d")}
            </div>
          </div>
        );
      })}
    </>
  );
};
